






























































































































































































import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import TsUpload from '@/components/upload.vue';

@Component({
  components: {
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() categories!: any[];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            const res = await this.$store.dispatch('poster/add', {
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  async mounted() {
    if (this.editId > 0) {
      this.spinLoading = true;
      const res = await this.$store.dispatch('poster/detail', {
        id: this.editId,
      });
      if (res && res.Data && res.Data !== '{}') {
        this.formData = res.Data;
      }
      this.spinLoading = false;
    }
  }
}
